exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".yacht-slider[data-v-6bd10de4] img.cover-image{border-radius:4px}.highlight[data-v-6bd10de4] div{display:inline}.highlight-tag[data-v-6bd10de4]{font-weight:500;border-radius:2px;color:#fff;line-height:1rem}.old-price[data-v-6bd10de4]{text-decoration:line-through}.enquire-button[data-v-6bd10de4]{width:180px}.fill-discount[data-v-6bd10de4]{fill:var(--discount-primary)}.trip-highlight-pill[data-v-6bd10de4]{border-radius:2px;font-weight:700}@media screen and (min-width:601px)and (max-width:1200px){.enquire-button[data-v-6bd10de4]{width:175px}}", ""]);

// exports
